<template>
  <div>
    <van-nav-bar
      :title="groupName"
      left-arrow
      @click-left="$router.push('/channelroom')"
      class="navStyles"
    >
     <template #right>
        <van-icon
          name="friends-o"
          color="#ffffff"
          size="24px"
          @click="$router.push(
              { name: 'ChannelDetails', params: { account: account,groupname: groupName} }
              )"
        />
      </template>
      </van-nav-bar>
    <div
      class="chatWindowBody"
      id="windowBody"
      style="padding-top: 45px; padding-bottom: 60px; background: #ffffff"
    >
      <van-list
        v-model="listLoading"
        @load="loadHistory"
        :finished="finished"
      >
        <!-- ================================== Left message window ============================================ -->
        <van-row class="rowDesign" v-for="(m, index) in channel_list" :key="index">
          <ul v-if="m.action !== '888'">
            <li>
              <div v-bind:class="[m.sender != myAccount ? 'receive' : 'sent']">
                <van-col span="3" v-if="m.sender != myAccount">
                  <img
                    src="../assets/images/login_logo.png"
                    class="imageleft"
                  />
                </van-col>
                <van-col span="21">
                  <div
                    v-bind:class="[
                      m.sender != myAccount
                        ? 'messageStyle'
                        : 'messageStyleSent',
                    ]"
                  >
                    <div
                      v-bind:class="[
                        m.sender != myAccount
                          ? 'talk_bubble round tri_right left_top'
                          : 'talk_bubble round tri_right right_in',
                      ]"
                    >
                      <!-- ========================= Text ======================= -->
                      <p
                        v-if="m.format == 0"
                        style="font-size: 13px"
                        v-html="processContent(m.content)"
                      ></p>
                      <!-- ============================== Image ============================= -->

                      <img
                        v-if="m.format == 1"
                        v-bind:src="
                          chatUrl +
                          '/files/chat-space/' +
                          JSON.parse(m.content).image
                        "
                        style="width: 100%"
                        @click="
                          showImage(
                            chatUrl +
                              '/files/chat-space/' +
                              JSON.parse(m.content).image
                          )
                        "
                      />
                      <van-image-preview
                        v-model="show"
                        :images="images"
                        :maxZoom="10"
                        :showIndex="false"
                      >
                      </van-image-preview>

                      <!-- ================================= Video ========================= -->

                      <video v-if="m.format == 8" controls style="width: 100%">
                        <source
                          v-bind:src="
                            chatUrl +
                            '/files/chat-space/' +
                            JSON.parse(m.content).video
                          "
                          type="video/mp4"
                        />
                      </video>

                      <!-- ================================= File - pdf ========================= -->

                      <img
                        v-if="m.format == 3"
                        :src="fileType(m.content)"
                        @click="onFile(m.content)"
                        style="width: 90px; display: block"
                      />

                      <!-- ============================ DateTime =========================== -->

                      <p style=" color: #646566; font-size: 13px">
                        <span v-if="m.sender == myAccount">{{myName}}<br></span>
                        <span v-else-if="m.sendername">{{m.sendername}}<br></span>
                        <span v-else-if="m.senderName">{{m.senderName}}<br></span>
                        <span v-else>{{m.extra}}<br></span>
                        {{ getTime(m.timestamp) }}
                      </p>
                    </div>
                  </div>
                </van-col>
                <!-- ======================== show right side profile picture (sender image) ============= -->
                <van-col span="3" v-if="m.sender == myAccount">
                  <img
                    src="../assets/images/login_logo.png"
                    class="imageright"
                  />
                </van-col>
              </div>
            </li>
          </ul>
        </van-row>
      </van-list>

      <!-- ================================ message box and icon list =============================== -->
      <div v-if="writePermission == 1">
      <van-row class="messageBox" v-if="account !== 'system'">
        <van-row style="padding: 4px 10px">
          <van-field
            v-model="message"
            type="textarea"
            placeholder="请输入信息"
            rows="1"
            autosize
            style="
              padding: 10px;
              border: 1px solid #969799;
              max-height: 70px;
              overflow-y: scroll;
              border-radius: 8px;
            "
          />
        </van-row>
        <van-row style="text-align: left; padding: 4px 0px">
          <van-col span="3">
            <van-popover
              v-model="showPopoverEmoji"
              placement="top-start"
              trigger="click"
            >
              <ul style="width: auto">
                <li
                  v-for="(item, index) in emojiIcons"
                  :key="index"
                  @click="showPopoverEmoji = false"
                  style="padding: 5px; float: left"
                >
                  <van-image @click="onEmoj(item)" :src="item.text" />
                </li>
              </ul>

              <template #reference>
                <van-icon
                  name="smile-o"
                  size="30"
                  color="#646566"
                  style="padding-left: 10px"
                />
              </template>
            </van-popover>
          </van-col>
          <van-col span="3">
            <van-uploader :after-read="uploadImage">
              <van-icon
                name="photo-o"
                size="30"
                color="#646566"
                style="padding-left: 10px"
              />
            </van-uploader>
          </van-col>
          <van-col span="3">
            <van-uploader :after-read="fileUpload" accept="*">
              <van-icon
                name="debit-pay"
                size="30"
                color="#646566"
                style="padding-left: 10px"
              />
            </van-uploader>
          </van-col>
          <van-col span="3">
            <van-uploader :after-read="uploadVideo" accept="video/*">
              <van-icon
                name="video-o"
                size="30"
                color="#646566"
                style="padding-left: 10px"
              />
            </van-uploader>
          </van-col>
          <van-col span="12" style="text-align: right; padding-right: 10px">
            <van-button
              @click="sendMessage(0)"
              icon="share"
              color="#646566"
              style="height: 28px"
            >
              发送
            </van-button>
          </van-col>
        </van-row>
      </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import eventBus from "../assets/js/eventBus";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  name: "ChannelRoomUser",
  data() {
    return {
      lastMsgID:false,
      pageNo:0,
      myName:"",
      myAccount: "",
      readPermission: "",
      writePermission: "",
      groupName: "", 
      chatUrl: localStorage.getItem('chat_api'),
      account: null,
      selectedUser: {
        user: { username: "" },
      },
      channel_list: [],
      message: "",
      show: false,
      images: [require("@/assets/images/login_logo.png")],
      showPopoverEmoji: false,
      emojiIcons: [
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/0.png",
          key: "[微笑]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/1.png",
          key: "[爱你]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/2.png",
          key: "[拜拜]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/3.png",
          key: "[悲伤]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/4.png",
          key: "[鄙视]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/5.png",
          key: "[闭嘴]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/6.png",
          key: "[馋嘴]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/7.png",
          key: "[吃惊]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/8.png",
          key: "[鼓掌]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/9.png",
          key: "[哈哈]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/10.png",
          key: "[害羞]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/11.png",
          key: "[黑线]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/12.png",
          key: "[可爱]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/13.png",
          key: "[可怜]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/14.png",
          key: "[亲亲]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/15.png",
          key: "[生病]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/16.png",
          key: "[偷笑]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/17.png",
          key: "[挖鼻]",
        },
        {
          text:
            localStorage.getItem('chat_api') + "/resource/layim/images/face/18.png",
          key: "[委屈]",
        },
      ],
      listLoading: false,
      systemPage: 0,
      finished: false,
    };
  },
  methods: {
    getPermission(){
        let that = this;
        that.loadChannels = true;
        that
        .$wonderChat({
          url: "api/group/getPermission/"+that.account,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          let resData = res.data;
          if(resData.code == 200){
            that.readPermission = resData.data.read;
            that.writePermission = resData.data.write;
          } 
        });
    },
    showImage(image) {
      this.images = [image];
      this.show = true;
    },
    loadMessageList() {
        this.myName = this.$store.state.wonder_chat_login_account.name;
        this.selectedUser = this.$store.state.channel_list.find(
          (o) => o.id == this.account
        );
        if (this.selectedUser !== null) {
          this.channel_list = this.selectedUser.messages;
        }
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 500);
      this.readUnreadMessages();
    },
    loadMessageHistory() {
      let that = this;
      that.listLoading = true;
      let lastMessageId =
        that.channel_list.length > 0
          ? that.channel_list[that.channel_list.length - 1].id
          : 0;
      if(lastMessageId == 0){
        that.lastMsgID = true;
      }
      let page = that.pageNo;
        if(that.lastMsgID){
          lastMessageId = 0;
        }else{
          lastMessageId = that.channel_list[that.channel_list.length - 1].id;
        }
      that
        .$wonderChat({
          url: `${localStorage.getItem('chat_api')}/api/message/getMessageHistoryChannelPaginated/${lastMessageId}/${that.account}/${page}?type=1`,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {
          },
        })
        .then((res) => {
          Toast.loading();
          that.listLoading = false;
          let data = res.data;
          if (data.code == 200){
              let dataList = data.dataList;
              if(dataList.length == 0){
                that.finished = true;
              }else{
                that.channel_list = that.channel_list.concat(data.dataList); 
                that.pageNo = page + 1;
                if (data.dataList.length < 20){
                  for(let i=0;i<(that.channel_list).length;i++){
                    (that.channel_list).sort(function(x, y){
                        return x.timestamp - y.timestamp;
                    })
                  }
                   if ((that.channel_list).length > 0) {
                    that.$store.commit("addMessageToHistoryChannel", {
                      account: that.account,
                      data: that.channel_list,
                    });
                   }
                   that.loadMessageList();
                   that.finished = true;
                   Toast.clear(); 
               }
              }

          }
          setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
          }, 1000);
        });
    },
    loadHistory() {
      this.loadMessageHistory();
    },
    readUnreadMessages() {
      this.channel_list.forEach((e) => {
        if (!e.read) {
          this.readRequest(e.id, this.account, e);
        }
      });
    },
    readRequest(id, account, message) {
      let that = this;
      that
        .$wonderChat({
          url: `${localStorage.getItem('chat_api')}/api/message/read/${id}/${account}`,
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          let data = res.data;
          message.read = true;
          this.selectedUser.unread <= 0
            ? (this.selectedUser.unread = 0)
            : (this.selectedUser.unread -= 1);
        });
    },
    uploadImage(file) {
      this.uploadFile(file, 3);
    },
    uploadVideo(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.uploadApiFile(formData, 8);
    },
    fileUpload(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.uploadApiFile(formData, 3);
    },
    uploadApiFile(formData, format) {
      let that = this;
      Toast.loading();
      that
        .$wonderChat({
          url: `${localStorage.getItem('chat_api')}/api/file/file`,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 200) {
            Toast.clear();
            switch (format) {
              case 8:
                var content = {
                  duration: 2,
                  image: "73859a7c9b404f16b4c818b0d2983a9c.jpg",
                  mode: 1,
                  size: "5",
                  video: data.data.file,
                };
                that.sendMessage(8, content);
                break;
              case 3:
                var content = {
                  file: data.data.file,
                  name: data.data.original,
                  size: "24280",
                };
                that.sendMessage(3, content);
                break;
              default:
                break;
            }
          } else {
            Toast.clear();
          }
        });
    },
    uploadFile(file, format) {
      let that = this;
      let formData = new FormData();
      formData.append("file", file.file);
      Toast.loading();
      that
        .$wonderChat({
          url: `${localStorage.getItem('chat_api')}/web/file`,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 200) {
            Toast.clear();
            that.sendMessage(1, data.data);
          } else {
            Toast.clear();
          }
        });
    },
    sendMessage(format = 0, content) {
      switch (format) {
        case 0:
          content = this.message;
          this.sendMessageApi(content, format, this.account);
          break;
        case 1:
          this.sendMessageApi(JSON.stringify(content), format, this.account);
          break;
        case 8:
          this.sendMessageApi(JSON.stringify(content), format, this.account);
          break;
        case 3:
          this.sendMessageApi(JSON.stringify(content), format, this.account);
          break;
        default:
          break;
      }
      this.message = "";
    },
    sendMessageApi(content, format, receiver) {  
      let that = this;
      let data = {
        content: content,
        action: "1",
        sender: localStorage.getItem("user_number"),
        receiver: that.account,
        format: format,
      };

      that
        .$wonderChat({
          url: `${localStorage.getItem('chat_api')}/api/message/send`,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: data,
        })
        .then((res) => {
          if (res.data.code == 200) {
            data.timestamp = res.data.timestamp;
            data.id = res.data.id;
            data.read = true;

            that.$store.commit("setMessage", {
              message: data,
              caller: that,
              sentMessage: true,
            });
            setTimeout(() => {
              window.scrollTo(0, document.body.scrollHeight);
            }, 1000);
          }
        });
    },
    getTime(timestamp) {
      return moment(timestamp).format("YYYY-MM-DD HH:mm");
    },
    fileType(content) {
      let fileNameArray = JSON.parse(content).name.split(".");
      let fileType = fileNameArray[fileNameArray.length - 1];
      switch (fileType) {
        case "pdf":
          return require("../assets/images/chat_files/pdf.png");
          break;
        case "doc":
          return require("../assets/images/chat_files/doc.png");
          break;
        case "docx":
          return require("../assets/images/chat_files/doc.png");
          break;
        case "ppt":
          return require("../assets/images/chat_files/ppt.png");
          break;
        case "xls":
          return require("../assets/images/chat_files/xls.png");
          break;
        case "xlsx":
          return require("../assets/images/chat_files/xls.png");
          break;
        case "jpeg":
          return require("../assets/images/chat_files/jpeg.png");
          break;
        case "jpg":
          return require("../assets/images/chat_files/jpeg.png");
          break;
        case "mp3":
          return require("../assets/images/chat_files/mp3.png");
          break;
        case "png":
          return require("../assets/images/chat_files/png.png");
          break;
        case "rar":
          return require("../assets/images/chat_files/rar.png");
          break;
        case "txt":
          return require("../assets/images/chat_files/txt.png");
          break;
        case "zip":
          return require("../assets/images/chat_files/zip.png");
          break;
        case "gif":
          return require("../assets/images/chat_files/gif.png");
          break;

        default:
          return require("../assets/images/chat_files/def.png");
          break;
      }
    },
    onEmoj(item) {
      this.message += "face" + item.key;
    },
    processContent(content) {
      let that = this;
      content = content.replace(/face\[([^\s\[\]]+?)\]/g, function (face) {
        //转义表情
        var alt = face.replace(/^face/g, "");
        var imgPath = that.emojiIcons.find((o) => alt === o.key);
        return (
          '<img alt="' +
          alt +
          '" title="' +
          alt +
          '" src="' +
          imgPath.text +
          '">'
        );
      });
      return content;
    },
    onFile(content) {
      let url = this.chatUrl + '/files/chat-space/' + JSON.parse(content).file;
      window.open(url,"_self");
    },
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push("/login");
      }
    },
  },
  computed: {},
  mounted: function () {
    this.isLogin();
    eventBus.$on("readMessage", (data) => {
      this.readUnreadMessages();
    });
    this.myAccount = localStorage.getItem("user_number");
    this.account = this.$route.params.account;
    this.groupName = this.$route.params.groupname;
    this.getPermission();
    if (this.account == null) {
      alert("invalid account number"); //TODO add proper error message;
      this.$router.go(-1);
      return;
    }
    this.selectedUser = this.$store.state.channel_list.find((o) => o.id == this.account);
    if (this.selectedUser !== null) {
      this.channel_list = this.selectedUser.messages;
    }
    if((this.channel_list).length > 0){
      this.loadMessageList();
    }
  
    
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.messageStyle {
  padding-top: 12px;
  text-align: left;
  line-height: 20px;
}

.messageStyleSent {
  padding-top: 12px;
  text-align: right;
  line-height: 20px;
}

.messageStyleSent p {
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  text-align: justify;
  margin: 0px;
}

.messageStyle p {
  /* remove webkit p margins */
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  text-align: justify;
  margin: 0px;
}

.messageBox {
  position: fixed;
  bottom: 43px;
  left: 0px;
  width: 100%;
  background: #ffffff;
}

.rowDesign {
  padding: 0px 10px;
}

.sent {
  float: unset;
  /* display: inline-flex; */
}

.receive {
  /* display: inline-flex; */
  text-align: right;
}

.imageleft {
  width: 30px;
  border-radius: 50%;
  float: left;
  margin: 6px 8px 0 0;
  height: 30px;
}

.imageright {
  width: 30px;
  border-radius: 50%;
  float: right;
  margin: 6px 0 0 8px;
  height: 30px;
}

.dividerStyle {
  background: #c8c9cc;
  padding: 4px 12px;
  border-radius: 5px;
  color: #000000;
}

.talk_bubble {
  display: inline-block;
  position: relative;
  width: auto;
  height: auto;
  background-color: #dcdee0;
  padding: 12px;
}

.tri_right.border.left_top:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -40px;
  right: auto;
  top: -8px;
  bottom: auto;
  border: 32px solid;
  border-color: #666 transparent transparent transparent;
}
.tri_right.left_top:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -14px;
  right: auto;
  top: 6px;
  bottom: auto;
  border: 14px solid;
  border-color: #dcdee0 transparent transparent transparent;
}

.tri_right.border.right_in:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -40px;
  top: 30px;
  bottom: auto;
  border: 20px solid;
  border-color: #666 transparent transparent #666;
}
.tri_right.right_in:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -16px;
  top: 4px;
  bottom: auto;
  border: 9px solid;
  border-color: #dcdee0 transparent transparent #dcdee0;
}

.round {
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/ChannelRoomUser.vue